<h2 mat-dialog-title>Sélectionner un bien</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="propSelectForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field>
          <mat-label>Bien</mat-label>
          <mat-select required formControlName="propertyId">
            <mat-option *ngFor="let prop of props" [value]="prop.uid"> {{ prop.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="f('propertyId').hasError('required')">Champs requis</mat-error>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Valider" type="submit">
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
